export const EduHistory = [
  {
    id: 1,
    school: 'The Federal Polytechnic Ede(ND)',
    date: '2019 - 2021',
    description: 
      'Graduated from The Federal Polytechnic Ede with a National Diploma (Upper Credit) in Computer Science '
  },
  {
    id: 2,
    school: 'The Federal Polytechnic Ede(HND)',
    date: '2021- Present',
    description:
      'Currently studying at the The Federal Polytechnic Ede'
  }
]
